import { useFlags } from "@/utils/flagsmith/useFlags";
import clsx from "clsx";

export const enum DataSource {
    FINANCE_API = "finance-api",
    LEGACY_BACKEND = "legacy-backend",
    SFDC = "sfdc",
    FINANCE_LAB = "finance-lab",
    MEMO_TEXT = "memo-text",
}

export const DATA_SOURCE_COLORS = {
    [DataSource.FINANCE_API]: "text-blue-500",
    [DataSource.LEGACY_BACKEND]: "text-cyan-500",
    [DataSource.SFDC]: "text-green-500",
    [DataSource.FINANCE_LAB]: "text-purple-500",
    [DataSource.MEMO_TEXT]: "text-orange-500",
} as const;

export const SOURCE_LABEL_COLORS = {
    [DataSource.FINANCE_API]: "text-blue-500",
    [DataSource.LEGACY_BACKEND]: "text-cyan-500",
    [DataSource.SFDC]: "text-green-500",
    [DataSource.FINANCE_LAB]: "text-purple-500",
    [DataSource.MEMO_TEXT]: "text-orange-500",
} as const;

export function useColorizedValue(
    value: string | number | undefined,
    source: DataSource,
    fieldKey?: string,
) {
    const flags = useFlags();
    const showDataSources = flags.enabled("show-data-sources");

    const stringValue = value?.toString() || "-";

    // Always return the value, but only add color classes when flag is enabled and we have a real value
    if (!showDataSources) {
        return {
            value: stringValue,
            className: "",
            source: null,
            sourceClassName: "",
        };
    }

    return {
        value: stringValue,
        className: clsx(DATA_SOURCE_COLORS[source], "font-medium"),
        source: fieldKey || source,
        sourceClassName: clsx(DATA_SOURCE_COLORS[source], "font-medium"),
    };
}
